import { getEnvironmentLabel } from "@client/lib/environmentTint";
import { cn } from "@client/utils/cn";
import { GitMergeIcon } from "lucide-react";

export function Logo() {
  return (
    <div className="bg-primary text-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
      <GitMergeIcon className="size-5" />
    </div>
  );
}

/**
 * The logo with the environment name ("staging" / "dev") written across the
 * tile in tinted environments — a color alone is easy to forget the meaning
 * of. The label is absolutely positioned INSIDE the tile so the app bar's
 * layout never rearranges around it (production renders pixel-identical to
 * the plain logo).
 */
export function EnvironmentBadgedLogo({ className }: { className?: string }) {
  const label = getEnvironmentLabel();
  return (
    <div className={cn("relative", className)}>
      <Logo />
      {label != null && (
        <span className="pointer-events-none absolute inset-x-0 bottom-0 rounded-b-lg bg-black/60 text-center text-[7px] leading-[10px] font-semibold tracking-wide text-white uppercase">
          {label}
        </span>
      )}
    </div>
  );
}
